import axios from "../../utils/axios";

async function fetchTrendingItems() {
  return await axios.get("/single/analytics/trending-products");
}

async function fetchSales() {
  return await axios.get("/single/analytics/sales");
}

async function fetchByDateRange(params) {
  return await axios.get("/single/analytics/date-range-sales", { params });
}

const analyticService = {
  fetchTrendingItems,
  fetchByDateRange,
  fetchSales,
};

export default analyticService;
